<template>
  <div>
    <div class="app-showcase-process-step__one mb-40">
      <div class="container-fluid container-fluid--cp-150">
        <div class="row align-items-center">
          <div class="col-lg-5 col-md-5">
            <div class="app-showcase-process-step__media text-center wow move-up">
              <img :src="img" class="img-fluid" alt="thumbnail" />
            </div>
          </div>
          <div class="col-lg-7 col-md-7">
            <div class="app-showcase-process-step__content section-space--mt_40">
              <div class="app-showcase__inner">
                <h4 class="font-weight--light wow move-up section-space--mb_20">{{ title }}</h4>
                <div class="wow move-up">
                  <button class="scroll btn btn--green">
                    <a href="/login">Log In & Manage Pixel Profile</a>
                  </button>
                </div>
                <div class="sub-text section-space--mb_40 wow move-up">
                  or start playing PixelDebates:
                  <a
                    class="hover-style-link hover-style-link--green"
                    target="_blank"
                    href="https://play.pixeldebates.com"
                    >play.pixeldebates.com</a
                  >
                </div>
                <div class="sub__title mb-20 wow move-up">
                  <h6 class="font-weight--blod">{{ subtitle }}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterMain FooterStyle="bg_drak-footer" />
  </div>
</template>

<script>
import FooterMain from '@/components/FooterMain'

export default {
  name: 'VerifyEmailSuccess',
  components: {
    FooterMain,
  },
  data() {
    return {
      img: require('../assets/img/hero/startup/top.png'),
      subtitle: '',
      title: 'Email Successfully Verified.',
      desc: '',
    }
  },
  async mounted() {
    if (this.$store.getters.user) {
      this.$router.push('/profile')
    }
  },
  computed: {
    email() {
      return this.$route.query.email
    },
  },
  methods: {
    onReset(event) {
      event.preventDefault()
      // Reset  form values
      this.form.code = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
}
</script>
